//#region Imports and Global Definitions
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { StyleSheet, View, SafeAreaView, Platform, useWindowDimensions, Pressable, FlatList, TouchableOpacity } from 'react-native';
import { useTheme } from '@react-navigation/native';
import { createCommonStyles } from '../../../../styles/commonStyles';
import CustomLabel from '../../../../components/CustomLabel/CustomLabel';
import CustomInput from '../../../../components/CustomInput';
import CustomButton from '../../../../components/CustomButton';
import { ActivityIndicator, Card } from 'react-native-paper';
import { showMessage } from "react-native-flash-message";
import HRAdminDepartmentsScreen from './HRAdminDepartmentsScreen';
import Ionicons from "@react-native-vector-icons/ionicons/static";
import CustomDropDown from '../../../../components/CustomDropDown/CustomDropdown'
import { useCompany } from '../../../../hooks/useCompany';
var _ = require('lodash');

// * Language
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { useSettingsContext } from '../../../../hooks/useSettingsContext';
import { useTableHelper } from '../../../../hooks/useTableHelper';


const ServiceLinesListView = React.memo(({ item, index, handleEditPress, employees,
    handleDeleteServiceLine, handlePress, styles, d365, props, t, duplicates, hasChildren, insertData
}) => {

    const [showAdditionalLocationInfo, setAdditionalLocationInfo] = useState(false);

    let errorMark = false;
    let errorAttr = '';

    duplicates.forEach(duplicate => {
        if (duplicate.attrVal.includes(item[duplicate.attribute])) {
            errorMark = true;
            errorAttr = duplicate.attrVal;
        }
    });

    useEffect(() => {
        //TODO
    }, [showAdditionalLocationInfo])

    const onShowAdditionalLocationInfoPress = (item) => {
        setAdditionalLocationInfo(!showAdditionalLocationInfo)
    }
    return (
        <View>
            <SafeAreaView>
                {props.showDepartments ?
                    <SafeAreaView
                        style={[{ alignContent: 'center' }]}>
                        <CustomLabel
                            value={item.description === "" ? item.servCode.toUpperCase() : item.description.toUpperCase()}
                            type="BRANCHES_WHEN_SHOWING_LOCATIONS" />

                    </SafeAreaView>
                    :
                    <SafeAreaView>
                        <SafeAreaView
                            style={styles.row}>

                            {/* //* Always Visible */}
                            <SafeAreaView
                                style={styles.itemrow}>
                                <CustomLabel
                                    value={t('common:servCode')}
                                    type='SUBTITLENOFLEX' />
                                <CustomInput
                                    value={item?.servCode}
                                    setValue={(e) => handleEditPress(index, item, 'servCode', e)}
                                    maxLen={3}
                                    type={errorMark && errorAttr === item.servCode ? "MISSING_BRANCHES_CODE" : "MAININPUT"}
                                    editable={props.showDepartments ? false : true}
                                />
                            </SafeAreaView>
                            <SafeAreaView
                                style={styles.itemrow}>
                                <CustomLabel
                                    value={t('common:description')}
                                    type='SUBTITLENOFLEX' />
                                <CustomInput
                                    value={item.description}
                                    setValue={(e) => handleEditPress(index, item, 'description', e)}
                                    maxLen={50}
                                    type="MAININPUT"
                                    editable={props?.showDepartments ? false : true}
                                />
                            </SafeAreaView>
                            <SafeAreaView>
                                <CustomButton
                                    iconName={!showAdditionalLocationInfo ? 'chevron-forward-outline' : 'chevron-down-outline'}
                                    onPress={() => {
                                        onShowAdditionalLocationInfoPress(item, index)
                                    }}
                                    text={t('common:additionalInfos')}
                                    show='PART'
                                    type='PART'
                                    textTop='0'
                                    sz={30} />
                            </SafeAreaView>
                            <SafeAreaView style={styles.justMargin}>
                                {!hasChildren[item.servLineID] &&
                                    <CustomButton
                                        iconName='trash-outline'
                                        onPress={() => {
                                            handleDeleteServiceLine(item, index, 'servLineID')
                                        }}
                                        show='PART'
                                        type='PART'
                                        textTop='2'
                                        sz={30} />
                                }
                                {/* Do not allow the user to insert departments when the service line is new and not saved. */}
                                {!insertData.includes(item.servLineID) &&
                                    <CustomButton
                                        iconName='ellipsis-vertical-outline'
                                        onPress={() => {
                                            handlePress(item, index)
                                        }}
                                        show='HOME_BELL'
                                        type='HOME_BELL'
                                        textTop='2'
                                        sz={30} />
                                }
                            </SafeAreaView>
                        </SafeAreaView>
                        {showAdditionalLocationInfo &&
                            <SafeAreaView style={styles.row}>
                                {employees.length > 0 &&
                                    <SafeAreaView
                                        style={styles.item}>
                                        <CustomLabel
                                            value={t('common:headOfFunction')}
                                            type='SUBTITLE' />
                                        <CustomDropDown
                                            defValue={item?.headID}
                                            options={employees}
                                            value={item?.headID}
                                            type="SERVICE_LINES"
                                            setValue={(e) => handleEditPress(index, item, 'headID', e)}
                                        />
                                    </SafeAreaView>
                                }
                                <SafeAreaView
                                    style={styles.item}>
                                    <CustomLabel
                                        value={t('common:regionalCode')}
                                        type='SUBTITLE' />
                                    <CustomInput
                                        value={item.regionalCode}
                                        setValue={(e) => handleEditPress(index, item, 'regionalCode', e)}
                                        maxLen={3}
                                        type="MAININPUT"
                                        editable={props.showDepartments ? false : true}
                                    />
                                </SafeAreaView>
                                {d365 &&
                                    <SafeAreaView
                                        style={styles.item}>
                                        <CustomLabel
                                            value={t('common:d365Code')}
                                            type='SUBTITLE' />
                                        <CustomInput
                                            value={item["d365Code"]}
                                            setValue={(e) => handleEditPress(index, item, 'd365Code', e)}
                                            maxLen={50}
                                            type="MAININPUT"
                                            editable={props.showDepartments ? false : true}
                                        />
                                    </SafeAreaView>
                                }
                            </SafeAreaView>
                        }
                    </SafeAreaView>
                }
            </SafeAreaView>
        </View >
    )
})

const HRAdminServiceLinesScreen = ({ props }) => {

    //#region Const Definitions
    const { width, height } = useWindowDimensions();
    const isPlatformWeb = (Platform.OS === 'web' && width > 992 ? false : true);
    const { colors } = useTheme();
    const common = createCommonStyles(colors);
    const styles = makeStyles(colors, width, height, isPlatformWeb);
    const [isLoading, setIsLoading] = useState(true);
    const [serviceLinesData, setServiceLinesData] = useState([]);
    const [changes, setChanges] = useState({});
    const [noChangesServiceLines, setNoChangesServiceLines] = useState([]);
    const [selectedServiceLines, setSelectedServiceLines] = useState(null);
    const [selectedServLevel, setSelectedServLevel] = useState(null);
    const [refreshAfterSave, setRefreshAfterSave] = useState(false);
    const [employees, setEmployees] = useState([]);
    const ref = useRef(null);
    const companyRef = useRef(null);
    const [buttonStates, setButtonStates] = useState({
        pressed: {}
    })
    const { d365 } = useSettingsContext();
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const { getServiceLinesData, insertServLines, updateServLines, deleteServLines, getDepartments } = useCompany();
    const { rowEdit, rowDelete, rowAdd, handleCancelChanges, hasDuplicates } = useTableHelper();
    const [insertData, setInsertData] = useState([]);
    const [deletedItems, setDeletedItems] = useState([]);
    const [duplicates, setDuplicates] = useState([])
    const [hasChildren, setHasChildren] = useState([]);
    //#endregion

    //#region Language
    const { t, i18n } = useTranslation();
    //#endregion

    //#region UseEffect
    useEffect(() => {
        if ((companyRef.current !== null) && companyRef.current !== props.selectedCompany) {
            props.goBackFunctions();
            companyRef.current = props.selectedCompany;
            return;
        }
        companyRef.current = props.selectedCompany;
        getServiceLinesData({ props }).then((arr) => {
            setChanges({});
            setServiceLinesData(arr);
            setNoChangesServiceLines([...arr])

            setEmployees(props.companyEmployees);
            getDepartments({ props }).then((res) => {
                const matchedServLineIDs = arr.reduce((acc, dept1) => {
                    const match = res.data.some(dept2 => dept2.servCode === dept1.servCode);
                    acc[dept1.servLineID] = match ? dept1.servCode : undefined;
                    return acc;
                }, {});
                setHasChildren(matchedServLineIDs);
                setRefreshAfterSave(false);
                setIsLoading(false);
            })
        }).catch(() => {
            setIsLoading(false);
        })
    }, [props.selectedCompany, props.selectedFunction, refreshAfterSave])

    //#endregion

    //#region Helpers

    const getSelectedHeadIDs = (arr, employees) => {
        return arr.reduce((acc, obj) => {
            const employee = employees.find(employee => employee.value === obj.headID);
            acc[obj.servLineID] = { headID: employee ? employee.value : '' };
            return acc;
        }, {});
    };

    const resetPressedKey = () => {
        setButtonStates((prevState) => {
            const newPressedState = Object.keys(prevState.pressed).reduce((acc, key) => {
                acc[key] = false;
                return acc;
            }, {});

            return {
                ...prevState,
                pressed: newPressedState,
            };
        });
    };

    const validateInput = () => {
        let ret = [true, t('common:validationSuccess')]
        serviceLinesData.forEach((itr) => {
            if (itr.servCode === '' || !itr.hasOwnProperty('servCode'))
                ret = [false, t('common:mandatoryCodeNotGivenServLines')];
            if (itr.description === '')
                ret = [false, t('common:descEmpty')]
        })
        return (ret)
    }

    const removeFromChangesAfterSave = () => {
        props.setChanges([])
        setDeletedItems([])
    }

    const showSwall = async () => {
        return Swal.fire({
            title: `<text style="font-family:'Roboto-Medium', font-size:16px">${t('common:changeServiceLineMessage')}</text>`,
            icon: "warning",
            showCancelButton: true,
            reverseButtons: true,
            cancelButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">${t('common:cancel')}</text>`,
            cancelButtonColor: '#d3d3d3',
            confirmButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">${t('common:confirmMessage')}</text>`,
            confirmButtonColor: '#A0A2FF',
        });
    }

    const checkIfUnsavedChanges = (hasChanges) => {
        setHasUnsavedChanges(hasChanges);
    }

    //#endregion

    //#region Handlers

    const handleEditPress = useCallback((index, item, key, value) => {
        if (item[key] === value) return;
        rowEdit(index, item, key, value, props.changes, props.setChanges, serviceLinesData, setServiceLinesData);
        props.checkIfUnsavedChangesInServLines(true);
    }, [])

    const handleSave = async () => {
        let newPromises = [];
        let deleteSucc = { status: true, message: "" };
        let insertSucc = true;
        let updateSucc = true;
        let valid = true;

        // * Do not save if Changes table is empty
        if (Object.entries(props.changes).length == 0 && deletedItems.length == 0) {
            showMessage({
                message: t('common:noChanges'),
                type: "danger",
                duration: 3000,
            })
            return
        }

        const attributesToIgnore = ["servLevel", "description", "headID", "regionalCode", "d365Code", "topServCode", "topServLevel", "oldServCode", "departmentsCnt", "servLineID"];

        if (serviceLinesData.length > 0)
            Object.keys(serviceLinesData[0]).forEach(key => {
                //* Ignore Keys that we know can be duplicated 
                if (!attributesToIgnore.includes(key)) {
                    if (hasDuplicates(serviceLinesData, key, setDuplicates)) {
                        showMessage({
                            message: t('common:duplicates'),
                            type: "danger",
                            duration: 3000,
                        })
                        // * Abort Save if this is triggered.
                        valid = false;
                    }
                }
            });

        if (!valid)
            return null;

        let valRet = validateInput();
        if (!valRet[0]) {
            showMessage({
                message: valRet[1],
                type: "danger",
                duration: 3000,
            })
            return;
        }

        let dataForInsert = [];
        let dataForUpdate = [];

        Object.entries(serviceLinesData).forEach(([key, obj]) => {
            if (insertData.includes(obj.servLineID)) {
                dataForInsert.push(obj);
            }
            else dataForUpdate.push(obj);
        });

        if (Object.keys(dataForUpdate).length > 0) {
            newPromises.push(updateServLines({ props }, dataForUpdate)
                .then((res) => {
                    if (!res) updateSucc = false;
                    removeFromChangesAfterSave()
                })
                .catch(() => { }));
        }
        if (Object.keys(dataForInsert).length > 0) {
            newPromises.push(insertServLines({ props }, dataForInsert)
                .then((res) => {
                    if (!res) insertSucc = false;
                    removeFromChangesAfterSave()
                })
                .catch(() => { }));
        }
        if (deletedItems.length > 0) {
            newPromises.push(deleteServLines(deletedItems).then((res) => {
                if (!res) deleteSucc = false;
                removeFromChangesAfterSave()
            })
                .catch(() => { }));
        }

        try {
            await Promise.all(newPromises).then(() => {
                if (!insertSucc || !deleteSucc['status'] || !updateSucc) {
                    if (!insertSucc) {
                        showMessage({
                            message: t('common:primaryKeyViolation'),
                            type: "danger",
                            duration: 3000,
                        })
                    }
                    else
                        showMessage({
                            message: t('common:issueMessage'),
                            type: "error",
                            duration: 3000,
                        })
                }
                else if (insertSucc && deleteSucc['status'] && updateSucc) {
                    showMessage({
                        message: t('common:allOperationsSuccMess'),
                        type: "success",
                        duration: 3000,
                    })
                    setDuplicates([]);
                    setRefreshAfterSave(true);
                    props.checkIfUnsavedChangesInServLines(false);
                }
            });
        } catch (error) {
            setDuplicates([]);
            setRefreshAfterSave(true);
        }
    }

    const handleDeleteServiceLine = (item, index, attribute) => {
        rowDelete(item, index, attribute, props.changes, props.setChanges, serviceLinesData, setServiceLinesData, setDeletedItems, ref)
        if (!insertData.includes(item.servLineID))
            props.checkIfUnsavedChangesInServLines(true);
    }

    const handleAddNewServLine = () => {
        let temp = [...serviceLinesData];
        if (serviceLinesData.length === 0)
            temp = {
                servCode: "",
                servLevel: "",
                topServLevel: "",
                headID: "",
                regionalCode: "",
                description: "",
                d365Code: "",
                oldServCode: "",
                servLineID: ""
            }
        rowAdd(temp, setServiceLinesData, ['servLineID'], [], ref, t, [], [], undefined, undefined, insertData, setInsertData, id = 'servLineID');
    }

    const handlePress = async (item, index) => {
        if (!props.showDepartments) {
            props.setShowDepartments(!props.showDepartments);
            // props.toggleVisibility();
        }

        setSelectedServiceLines(item?.servCode);
        setSelectedServLevel(parseInt(item.servLevel, 10));
        if (selectedServiceLines === item.servCode && props.showDepartments)
            return;
        setButtonStates((prevState) => {
            const newPressedState = Object.keys(prevState.pressed).reduce((acc, key) => {
                acc[key] = false;
                return acc;
            }, {});
            newPressedState[index] = !prevState.pressed[index];
            return {
                ...prevState,
                pressed: newPressedState,
            };
        });
    }

    const handleGoBack = () => {
        if (props.showDepartments) {
            props.setShowDepartments(false);
            props.goBackFunctions(true);
            resetPressedKey();
        }
        setRefreshAfterSave(true);
    }

    //#endregion

    //#region Components

    const renderServiceLines = useCallback((item, index) => {
        if (props.showDepartments)
            return renderPressableServiceLines(item, index);
        return (
            <SafeAreaView>
                <Card
                    style={[common.cardstyle]} >
                    <Card.Content>
                        {renderServiceLine(item, index)}
                    </Card.Content>
                </Card>
            </SafeAreaView>
        )

    }, [serviceLinesData, buttonStates, hasChildren, hasUnsavedChanges, duplicates]);

    const renderServiceLine = (item, index) => {
        return (
            <ServiceLinesListView item={item} index={index}
                handleEditPress={handleEditPress}
                props={props}
                employees={employees}
                handleDeleteServiceLine={handleDeleteServiceLine}
                handlePress={handlePress}
                styles={styles}
                d365={d365}
                duplicates={duplicates}
                hasChildren={hasChildren}
                insertData={insertData}
                t={t}
            />
        )
    }

    const renderPressableServiceLines = (item, index) => {
        if (hasUnsavedChanges)
            return (
                <View
                    style={styles.button}>
                    <TouchableOpacity
                        onPress={() => {
                            if (Platform.OS === 'web') {
                                return showSwall().then((result) => {
                                    if (result.isConfirmed) {
                                        setHasUnsavedChanges(false);
                                        handlePress(item, index);
                                    };
                                });
                            }
                        }}>
                        <View>
                            <Card
                                style={[common.cardstyle, buttonStates.pressed[index] === true ? [common.cardstyle, styles.selectedButton] : null]} >
                                <Card.Content>
                                    {renderServiceLine(item, index)}
                                </Card.Content>
                            </Card>
                        </View>
                    </TouchableOpacity>
                </View >
            )
        else
            return (
                <Pressable onPress={() => { handlePress(item, index) }}>
                    <Card
                        style={[common.cardstyle, buttonStates.pressed[index] === true ? [common.cardstyle, styles.selectedButton] : null]} >
                        <Card.Content>
                            {renderServiceLine(item, index)}
                        </Card.Content>
                    </Card>
                </Pressable>
            )
    };
    //#endregion

    //#region Loading
    if (isLoading)
        return (
            <View style={styles.loader}>
                <ActivityIndicator animating={true} color={colors.blue} />
            </View>
        )
    //#endregion

    return (
        <SafeAreaView style={styles.mainView}>
            {props.showDepartments &&
                <TouchableOpacity onPress={() => { handleGoBack() }} style={styles.backButton}>
                    <Ionicons name="arrow-back" size={30} color="black" />
                </TouchableOpacity>
            }
            <SafeAreaView style={styles.rowView}>
                <SafeAreaView style={[styles.subMain]}>
                    {props.selectedCompany &&
                        <View style={styles.innerView}>
                            {!props.showDepartments &&
                                <View style={[styles.buttons, styles.functionalityButtons]}>
                                    <CustomButton
                                        text={t('common:createNewFunction')}
                                        onPress={() => { handleAddNewServLine() }}
                                        type='BUTTON_ADD'
                                        textTop='0'
                                        sz={15}
                                    />
                                    {(Object.keys(props.changes).length > 0 ||
                                        serviceLinesData.length > 0 ||
                                        deletedItems.length > 0) &&
                                        <CustomButton
                                            text={t('common:saveFunction')}
                                            onPress={() => { handleSave() }}
                                            type='BUTTON_SAVE'
                                            textTop='0'
                                            isGradient={true}
                                            sz={15}
                                        />
                                    }
                                    <CustomButton
                                        text={t('common:cancel')}
                                        onPress={() => {
                                            handleCancelChanges(setServiceLinesData, noChangesServiceLines, setDeletedItems, props.setChanges, setDuplicates);
                                            props.checkIfUnsavedChangesInServLines(false);
                                        }}
                                        type="BUTTON_CANCEL"
                                        textTop='0'
                                        sz={15}
                                    />
                                </View>
                            }
                            {!props.showDepartments && <SafeAreaView style={common.divider} />}
                            <View style={styles.servLinesView}>
                                <FlatList
                                    style={props.showDepartments ? styles.fullHeight : styles.fullWidth}
                                    data={serviceLinesData}
                                    keyExtractor={(item, index) => `${item.servLevelID}-${index}`}
                                    renderItem={({ item, index }) =>
                                        renderServiceLines(item, index)
                                    }
                                    scrollEnabled={true}
                                    refreshing={isLoading}
                                    ref={ref}
                                    ListEmptyComponent={
                                        <SafeAreaView style={common.listTitle}>
                                            isLoading ?
                                            <ActivityIndicator animating={true} color={colors.blue} />
                                            :
                                            <CustomLabel
                                                value={t("common:servLinesNoDataPreview")}
                                                type="NO_FUNCTIONS"
                                            />
                                        </SafeAreaView>
                                    }
                                    initialNumToRender={10}
                                />
                                {props.showDepartments ?
                                    <SafeAreaView style={styles.departmentsView}>
                                        <HRAdminDepartmentsScreen props={{
                                            selectedCompany: props.selectedCompany,
                                            selectedServCode: selectedServiceLines,
                                            selectedServLevel: selectedServLevel,
                                            companyEmployees: employees,
                                            checkIfUnsavedChangesInDepartments: checkIfUnsavedChanges,
                                            handleGoBack: handleGoBack,
                                            changes: changes,
                                            setChanges: setChanges
                                        }}
                                        />
                                    </SafeAreaView>
                                    : <></>
                                }
                            </View>

                        </View>
                    }
                </SafeAreaView>
            </SafeAreaView >
        </SafeAreaView >
    )
};

//#region Styles
const makeStyles = (colors, width) => StyleSheet.create({
    mainView: {
        flex: 1,
    },
    subMain: {
        borderRadius: 35,
        elevation: (Platform.OS === 'web' && width > 992 ? 3 : 0),
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.1,
        width: '100%'
    },
    rowView: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'center'
    },
    row: {
        flex: 1,
        margin: 10,
        flexDirection: "row",
        alignItems: 'center',
    },
    item: {
        flex: 1,
    },
    error: {
        color: colors.validation_error,
        alignSelf: 'center',
        fontSize: 14,
    },
    selectedButton: {
        borderWidth: 2,
        borderColor: colors.buttons_submit,
    },
    backButton: {
        alignSelf: 'flex-end',
        margin: 0
    },
    innerView: {
        flex: 1,
    },
    servLinesView: {
        flexDirection: 'row',
        margin: 10,
        height: '100%',
    },
    fullHeight: {
        height: '95%',
    },
    fullWidth: {
        height: '85%',
    },
    departmentsView: {
        width: '85%',
        height: '100%'
    },
    functionalityButtons: {
        justifyContent: 'flex-end'
    },
    buttons: {
        flexDirection: 'row',
        justifyContent: 'flex-end',
        width: '50%',
        alignSelf: 'flex-end',
    },
    loader: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '4%'
    },
    itemrow: {
        flex: 1,
        flexDirection: 'row',
    },
});


//#endregion

export default HRAdminServiceLinesScreen;